import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { MagnifyingGlassIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

const GlobalSearch = () => {
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  const [searchCategory, setSearchCategory] = useState('all');
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const history = useHistory();

  // Categories for search
  const categories = [
    { id: 'all', name: 'All' },
    { id: 'products', name: 'Products' },
    { id: 'designers', name: 'Designers' },
    { id: 'pages', name: 'Pages' }
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowTypeDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get current category name
  const currentCategory = categories.find(cat => cat.id === searchCategory)?.name || 'All';

  // Handle global search submission
  const handleGlobalSearch = (e) => {
    e.preventDefault();
    
    if (!globalSearchTerm.trim()) return;
    
    // Navigate based on search category
    if (searchCategory === 'products') {
      history.push(`/browse?q=${encodeURIComponent(globalSearchTerm)}`);
    } else {
      history.push(`/search?q=${encodeURIComponent(globalSearchTerm)}&type=${searchCategory}`);
    }
    
    setGlobalSearchTerm('');
  };

  return (
    <form 
      onSubmit={handleGlobalSearch} 
      className="relative flex-1 max-w-sm md:max-w-lg"
    >
      <div className="flex rounded-md border border-white bg-brand-teal">
        {/* Type selector dropdown */}
        <div className="relative" ref={dropdownRef}>
          <button
            type="button"
            className="h-10 px-3 text-white text-sm font-medium border-r border-white/40 hover:bg-brand-teal-light flex items-center rounded-l-md"
            onClick={() => setShowTypeDropdown(!showTypeDropdown)}
          >
            {currentCategory}
            <ChevronDownIcon className="h-4 w-4 ml-1" />
          </button>
          
          {showTypeDropdown && (
            <div className="absolute z-10 left-0 mt-1 w-40 bg-white border border-gray-300 rounded-md shadow-lg">
              {categories.map(category => (
                <button
                  key={category.id}
                  type="button"
                  className={`block w-full text-left px-4 py-2 text-sm ${
                    searchCategory === category.id 
                      ? 'bg-gray-100 text-gray-900' 
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                  onClick={() => { 
                    setSearchCategory(category.id);
                    setShowTypeDropdown(false);
                  }}
                >
                  {category.name}
                </button>
              ))}
            </div>
          )}
        </div>
        
        {/* Search input */}
        <input
          type="text"
          value={globalSearchTerm}
          onChange={(e) => setGlobalSearchTerm(e.target.value)}
          placeholder="Search for products, designers, etc..."
          className="w-full h-10 px-3 text-sm text-white bg-transparent border-none focus:outline-none focus:ring-0 placeholder-gray-200"
        />
        
        {/* Submit button */}
        <button
          type="submit"
          className="h-10 px-3 text-white hover:bg-brand-teal-light rounded-r-md"
          aria-label="Search"
        >
          <MagnifyingGlassIcon className="h-5 w-5" />
        </button>
      </div>
    </form>
  );
};

export default GlobalSearch; 